














import { Component, Vue } from 'vue-property-decorator';

import BugTrackerDetails from '@/components/frontpage/bugtracker/BugTrackerDetails.vue';
import BugTrackerGuideLines from '@/components/frontpage/bugtracker/BugTrackerGuideLines.vue';
import { BugTrackerCategoryViewObject } from '@/types/apiServerContract';
import { BugTrackerModule } from '@/store/modules/bugtracker/bugtracker.store';

@Component({
    components: { BugTrackerDetails, BugTrackerGuideLines }
})
export default class BugTracker extends Vue {
    get categories(): BugTrackerCategoryViewObject[] {
        return BugTrackerModule.categories;
    }

    async getCategories() {
        await BugTrackerModule.getCategories();
    }

    created() {
        this.getCategories();
    }
}
